import React from 'react';
import { Container } from '@material-ui/core';
import propTypes from 'prop-types';
import classnames from 'classnames';
import './Hexagon.scss';

const Hexagone = require('../../assets/images/Hexagone_ss_bord.png');

const renderLoader = (message, small) => (
    <div className="loader">
      <Container className="containerSecondaireSpinner">
        <div className={small ? 'container-small' : 'container'}>
          <div className={small ? 'wheel-small' : 'wheel'}>
            <ul className={small ? 'umbrella-small' : 'umbrella'}>
              <li className={small ? 'color-small' : 'color'} />
              <li className={small ? 'color-small' : 'color'} />
              <li className={small ? 'color-small' : 'color'} />
              <li className={small ? 'color-small' : 'color'} />
              <li className={small ? 'color-small' : 'color'} />
              <li className={small ? 'color-small' : 'color'} />
              <li className={small ? 'color-small' : 'color'} />
              <li className={small ? 'color-small' : 'color'} />
              <li className={small ? 'color-small' : 'color'} />
              <li className={small ? 'color-small' : 'color'} />
              <li className={small ? 'color-small' : 'color'} />
              <li className={small ? 'color-small' : 'color'} />
            </ul>
          </div>
          <div className={small ? 'clip-small' : 'clip'}>
            <img alt="" className="hexagonCapture" src={Hexagone} />
          </div>
          {!small && <div className="containerText">{message}</div>}
        </div>
      </Container>
    </div>
);

const SpinnerHexagone = ({ isLoading, children, small, message }) => (
    small ? (
        <div className="loader-container">
          {renderLoader(message, small)}
        </div>
    ) : (
        <div className={classnames('loader-container', isLoading && 'visible')}>
          {isLoading ? (
              renderLoader(message, small)
          ) : null}

          {children}
        </div>
    )
);


SpinnerHexagone.propTypes = {
  isLoading: propTypes.bool.isRequired,
  message: propTypes.string,
  small: propTypes.bool,
};

SpinnerHexagone.defaultProps = {
  message: 'Merci de patienter',
  small: false,
};

export default SpinnerHexagone;
